import { db, auth } from '@/plugins/firebase'
import firebase from 'firebase';
import 'firebase/app';
import { bus } from '@/main'

export async function getContent({ commit }, { collection, condition, mutation }) {
    var dataArr = []
    commit(mutation, dataArr)
    if (condition) {
        await db.collection(collection).where("state", "!=", "deleted").where(condition.leftVal, condition.operator, condition.rightVal).get().then(async function (docs) {
            if (docs.empty) {
                return
            }

            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }

            commit(mutation, dataArr)
        })
    } else {
        await db.collection(collection).where("state", "!=", "deleted").get().then(async function (docs) {
            if (docs.empty) {
                return
            }

            for (var i = 0; i < docs.size; i += 1) {
                var doc = docs.docs[i];
                dataArr.push(doc.data());
            }

            commit(mutation, dataArr)
        })
    }

}

export async function getEntitiesByRegion({ commit }, region) {
    console.log("region: ", region)
    var dataArr = []
    commit("updateReviewedEntities", dataArr)
    await db.collection("entities").where("state", "!=", "deleted").where("state", "==", "reviewed").where("region.id", "==", region.id).get().then(async function (docs) {
        if (docs.empty) {
            return
        }

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
        }

        commit("updateReviewedEntities", dataArr)
    })
}

export async function searchContent({ commit }, { collection, mutation, searchTerm }) {
    var dataArr = []
    commit(mutation, dataArr)

    await db.collection(collection).where("state", "==", "reviewed").where("searchTerms", "array-contains", searchTerm.toLowerCase()).get().then(async function (docs) {
        console.log("Searched Entities: ", searchTerm)
        if (docs.empty) {
            return
        }

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
        }

        console.log("Searched Entities: ", dataArr)

        commit(mutation, dataArr)
    })
}

export async function createNewContent({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {
        const ref = db.collection(collection).doc()

        function createKeywords(name) {
            const arrName = [];
            let curName = "";
            name.split("").forEach((letter) => {
                curName += letter;
                arrName.push(curName);
            });
            return arrName;
        }

        function generateKeywords(name) {
            const keywordTagName = createKeywords(name);
            return [...new Set(["", ...keywordTagName])];
        }

        if (details.title) {
            details.searchTerms = generateKeywords(details.title.toLowerCase());
        }

        


        const refObject = {
            id: ref.id,
            ...details,
            createdBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }


        ref.set(refObject).then(() => {
            console.log("Created new Content")
            bus.$emit("show-snackbar", { text: "New " + type + " Created!", color: "success" });
            resolve()
        }).catch((err) => {
            bus.$emit("show-snackbar", { text: err, color: "error" });
            reject()
        })
    })

}

export async function updateContent({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {

        function createKeywords(name) {
            const arrName = [];
            let curName = "";
            name.split("").forEach((letter) => {
                curName += letter;
                arrName.push(curName);
            });
            return arrName;
        }

        function generateKeywords(name) {
            const keywordTagName = createKeywords(name);
            return [...new Set(["", ...keywordTagName])];
        }

        if (details.title) {
            details.searchTerms = generateKeywords(details.title.toLowerCase());
        }

        const refObj = {
            ...details,
            updatedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }
        console.log("updating pin: ", details)
        db.collection(collection).doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: type + " updated!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })
    })
}

export async function deleteContent({ commit }, { details, collection, type }) {
    console.log("Pin To Delete: ", details)
    return new Promise((resolve, reject) => {

        const refObj = {
            ...details,
            state: "deleted",
            deletedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        db.collection(collection).doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: type + " deleted!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })

        // db.collection(collection).doc(details.id).delete().then(function () {
        //     bus.$emit("show-snackbar", { text: type + " Successfully Deleted!", color: "success" });
        //     resolve()
        // }).catch(function (error) {
        //     bus.$emit("show-snackbar", { text: error, color: "error" });
        //     reject()
        // });
    })
}

export async function getSubscribersByRegion({ commit }, { type, collection, mutation, region }) {
    var dataArr = []
    commit(mutation, dataArr)

    await db.collection(collection).where("entity.region.id", "==", region.id).where("state", "!=", "deleted").get().then(async function (docs) {
        if (docs.empty) {
            return
        }

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
        }

        commit(mutation, dataArr)
    })

}

export async function getSubscribers({ commit }, {collection, mutation}) {
    var dataArr = []
    commit(mutation, dataArr)

    await db.collection(collection).where("state", "!=", "deleted").get().then(async function (docs) {
        if (docs.empty) {
            return
        }

        for (var i = 0; i < docs.size; i += 1) {
            var doc = docs.docs[i];
            dataArr.push(doc.data());
        }

        commit(mutation, dataArr)
    })

}

export function createNewSubscriber({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {
        const ref = db.collection(collection).doc()
        const refObject = {
            id: ref.id,
            ...details,
            createdBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        }


        ref.set(refObject).then(() => {
            console.log("Created new Content")
            bus.$emit("show-snackbar", { text: "New "+type+" Created!", color: "success" });
            resolve()
        }).catch((err) => {
            bus.$emit("show-snackbar", { text: err, color: "error" });
            reject()
        })
    })
}

export function updateSubscriber({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {

        const refObj = {
            ...details,
            updatedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }
        console.log("updating Subscriber: ", details)
        db.collection(collection).doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text: type + " updated!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })
    })
}

export function deleteSubscriber({ commit }, { details, collection, type }) {
    return new Promise((resolve, reject) => {

        const refObj = {
            ...details,
            state: "deleted",
            deletedBy: {
                id: auth.currentUser.uid,
                email: auth.currentUser.email,
                name: auth.currentUser.displayName,
            },
            deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
        }

        console.log("deleting Subscriber: ", details)
        db.collection(collection).doc(details.id).set(
            refObj, { merge: true }).then(() => {
                bus.$emit("show-snackbar", { text:  type + " deleted!", color: "success" });
                resolve()
            }).catch((err) => {
                bus.$emit("show-snackbar", { text: err, color: "error" });
                reject()
            })
    })
}